import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import Navigation from './NavbarComponent';
import Stack from './StackComponent';
import Queue from './QueueComponent';
import Home from './HomeComponent';
import BFS from './BFSComponent';
import Footer from './FooterComponent';
import DFS from './DFSComponent';
import About from './AboutComponent';
import {developers} from '../shared/developers';

class Main extends Component{
    render(){
        return(
            <div>
                <Navigation/>
                <Switch>
                    <Route path="/home" component={Home}/>
                    <Route path="/stack" component={Stack}/>
                    <Route path="/queue" component={Queue}/>
                    <Route path="/bfs" component={BFS}/>
                    <Route path="/dfs" component={DFS}/>
                    <Route path="/about" component={()=><About developers={developers}/>}/>
                    <Redirect to="/home"/>
                </Switch>
                <Footer/>
            </div>
        );
    }
}

export default withRouter(Main);